import styles from './create-account-card.module.sass';
import classNames from 'classnames';
import { ArrowRightCircleIcon } from 'icons';

export const ToggleCreateAccountFormBox = ({ onClick }) => {
  return (
    <div className={classNames(styles['toggle-box'])} onClick={onClick}>
      新增駕駛帳號
      <ArrowRightCircleIcon />
    </div>
  );
};
